__turbopack_context__.v({
  "wrapper": "TGteeq_wrapper",
});
